import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/common/alert.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { LoginService } from 'src/app/services/login.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { ResourceService } from 'src/app/services/common/resource.service';
import { WishListService } from 'src/app/services/wishlist.service';
import { first } from 'rxjs';

@Component({
    selector: 'app-profile-authentication-page',
    templateUrl: './profile-authentication-page.component.html',
    styleUrls: ['./profile-authentication-page.component.scss']
})
export class ProfileAuthenticationPageComponent implements OnInit, AfterViewInit {
    hide: boolean = true;
    hidePassword = true;
    hidePasswordConfirm = true;

    submitted = false;

    isShowPassword: boolean = false;

    queryString = Object();
    rememberMe: boolean;
    resource: any = {};
    message: string;
    tokenValid = false;

    showSubmitButton: boolean = false;

    constructor(
        private router: Router,
        private alertService: AlertService,
        private formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private loginService: LoginService,
        private userInfoService: UserInfoService,
        private storageService: StorageService,
        private resourceService: ResourceService,
        private wishListService: WishListService,
    ) { }

    submittedLogin = false;
    loginForm: FormGroup;
    get f() { return this.loginForm.controls; }

    ngOnInit(): void {
        if (this.userInfoService.getLoginFlag()) {
            this.router.navigate(['my-dashboard']);
        }
        this.loadResoruce();

        this.resourceService.languageSubject.subscribe(response => {
            this.resource = response;
        });
        this.rememberMe = false;
        this.buildForm();
        this.queryString = this.activatedRoute.snapshot.queryParams;
        if (this.queryString?.token) {
            var token = JSON.parse(window.atob(this.queryString.token));
            this.loginService.verify_user(token).pipe(first()).subscribe((response: any) => {
                if (response.success) {
                    this.message = response.message;
                    this.tokenValid = response.success;
                    this.alertService.showSuccess(response.message);

                    if (response.data?.userInfo) {
                        let userData = response.data?.userInfo;

                        this.storageService.setValue(StorageKey.currentUser, JSON.stringify(userData));
                        this.storageService.setValue(StorageKey.authToken, response.data.token);
                        this.userInfoService.setUserInfo(userData);
                        this.userInfoService.setLoginFlag(true);
                        this.userInfoService.setToken(response.data.token);
                        this.storageService.loginSubject.next(true);
                    }
                }
                else {
                    this.storageService.removeValue(StorageKey.authToken);
                    this.storageService.removeValue(StorageKey.currentUser);
                    this.storageService.removeValue(StorageKey.rememberMe);
                }
                if (this.queryString?.returnUrl) {
                    this.router.navigateByUrl(decodeURIComponent(this.queryString?.returnUrl));
                }
            });
        } else {
            this.tokenValid = true;
        }

        if (this.queryString?.email) {
            this.f.email_phone.setValue(this.queryString?.email);
        }

        //this.listenToEmailPasswordChanges();
    }

    listenToEmailPasswordChanges(): void {
        this.loginForm.get('email_phone')?.valueChanges.subscribe(value => {
            if (this.loginForm.controls.email_phone.status == "INVALID")
                return;

            var logininfo: any = {
                "email": value.trim()
            }

            this.loginService.check_auth_method(logininfo).subscribe((response: any) => {
                const passwordControl = this.loginForm.get('password');

                //if (response.success) {
                if (response.data?.authType === 'password' || !response.data.exists) {
                    passwordControl?.setValidators([
                        Validators.required,
                        Validators.pattern('^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{6,20}$')
                    ]);
                    this.isShowPassword = true;
                } else {
                    passwordControl?.clearValidators();
                    this.isShowPassword = false;
                }
                // }
                // else {
                //     passwordControl?.clearValidators();
                //     this.isShowPassword = false;
                // }
                passwordControl?.updateValueAndValidity();

            });
        });
    }



    ngAfterViewInit() {
    }

    loadResoruce() {
        this.resourceService.loadResoruce().subscribe(
            response => {
                this.resource = response;
            });
    }

    buildForm(): void {
        this.loginForm = this.formBuilder.group({
            email_phone: ['', [Validators.required, this.emailOrPhoneValidator]],
            password: [''],
            rememberMe: [false]
        });
    }

    emailOrPhoneValidator(control: AbstractControl) {
        const value = control.value;
        if (!value) return null;

        const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        const phonePattern = /^[0-9]{10,15}$/; // Adjusted to allow 10 to 15 digits for phone

        const isValidEmail = emailPattern.test(value);
        const isValidPhone = phonePattern.test(value);

        return isValidEmail || isValidPhone ? null : { invalidInput: true };
    }

    togglePasswordVisibility() {
        this.hide = !this.hide;
    }
    toggleConfirmPasswordVisibility(): void {
        this.hidePasswordConfirm = !this.hidePasswordConfirm;
    }

    onSubmit() {
        this.submittedLogin = true;
        this.loginForm.controls['password'].setErrors(null);

        if (this.loginForm.invalid)
            return;

        var logininfo: any = {
            "email": this.f.email_phone.value.trim(),
            "password": this.f.password.value,
        }

        const rememberMe = this.f.rememberMe.value;

        this.loginService.login(logininfo).subscribe((res: any) => {
            if (res.success) {
                let loginResponse = res.data;
                if (loginResponse.token) {
                    let userData = loginResponse.userInfo;
    }
    }
    })

        this.loginService.login(logininfo).subscribe((res: any) => {
            if (res.success) {
                let loginResponse = res.data;
                if (loginResponse.token) {
                    let userData = loginResponse.userInfo;
                    this.storageService.setValue(StorageKey.currentUser, JSON.stringify(userData));
                    this.storageService.setValue(StorageKey.authToken, loginResponse.token);
                    this.userInfoService.setUserInfo(userData);
                    this.userInfoService.setLoginFlag(true);
                    this.userInfoService.setToken(loginResponse.token);
                    this.storageService.loginSubject.next(true);
                    if (userData?.countryId) {
                        this.storageService.setGlobalSearch(StorageKey.globalSearch, "countryId", userData?.countryId ? userData?.countryId : '');
                        if (userData?.stateId) {
                            this.storageService.setGlobalSearch(StorageKey.globalSearch, "stateId", userData?.stateId ? userData?.stateId : '');
                        }
                        if (userData?.cityId) this.storageService.setGlobalSearch(StorageKey.globalSearch, "cityId", userData?.cityId ? userData?.cityId : '');
                    }
                    this.storageService.storageSubject.next(this.storageService.getGlobalSearch());

                    this.activatedRoute.queryParams.subscribe(params => {
                        let returnUrl = params['returnUrl'];
                        if (returnUrl) {
                            if (returnUrl.includes("wishlist")) {
                                var campaignData = JSON.parse(atob(returnUrl.split("?")[1].replace("wishlist=", '')));

                                var wishListdata = {
                                    campaignId: campaignData.campaignId,
                                    isActive: true,
                                }
                                this.wishListService.add(wishListdata).subscribe(async (wishListresponse: any) => {
                                    if (wishListresponse.success) {
                                        this.alertService.showSuccess(campaignData.campaignName + " " + this.resource.wishlist_add);
                                    }
                                    else {
                                        this.alertService.showError(wishListresponse.message);
                                    }
                                    this.router.navigate(['/my-dashboard']);
                                });
                            }
                            else {
                                const urlParts = returnUrl.split("?");
                                const baseUrl = urlParts[0];
                                let queryParams: Record<string, string> = {};
                                // let queryParams = {};

                                if (urlParts.length > 1) {
                                    const queryString = urlParts[1];
                                    const queryArray = queryString.split("&");

                                    queryArray.forEach((param: string) => {
                                        const [key, value] = param.split("=");
                                        if (key && value) {
                                            queryParams[key] = value;
                                        }
                                    });
                                }
                                this.router.navigate([baseUrl], { queryParams });
                            }
                        }
                        else {
                            this.router.navigate(['/my-dashboard']);
                        }
                    });
                }
                else {
                    this.alertService.showError("Sorry,it seems there is some technical/network error");
                    this.storageService.loginSubject.next(false);
                }
                //Set a cookie with the user credentials if the "Remember Me" checkbox is checked
                if (rememberMe) {
                    // this.cookieService.set('currentUser', JSON.stringify(logininfo), 7);
                    this.storageService.setValue(StorageKey.rememberMe, 'yes');
                }
            }
            else {
                this.storageService.loginSubject.next(false);
                this.alertService.showError(res.message);
            }
        }, (err: any) => {
            this.storageService.loginSubject.next(false);
            this.alertService.showError(err.error.error.message);
        })
    }

    onClickSignUp() {
        this.activatedRoute.queryParams.subscribe(params => {
            let returnUrl = params['returnUrl'];
            if (returnUrl) {
                this.router.navigate(['/register'], { queryParams: { returnUrl: returnUrl } });
            }
            else
                this.router.navigate(['/register']);
        })
    }


    // loginWithGoogle() {
    //     this.loginService.googleLogin().then((result) => {
    //         if (result) {
    //             let returnUrl = "";
    //             this.activatedRoute.queryParams.subscribe(params => {
    //                 returnUrl = params['returnUrl'];

    //                 var googleRegModel: any = {
    //                     "email": result.user.email,
    //                     "uid": result.user.uid,
    //                 }

    //                 result.user.getIdToken().then((token) => {
    //                     this.storageService.setValue(StorageKey.authToken, token);

    //                     this.loginService.google_authentication(googleRegModel).pipe(first()).subscribe({
    //                         next: (response) => {
    //                             if (response.success) {
    //                                 this.storageService.setValue(StorageKey.currentUser, JSON.stringify(response.data.userInfo));
    //                                 this.storageService.setValue(StorageKey.authToken, response.data.token);
    //                                 this.userInfoService.setUserInfo(response.data.userInfo);
    //                                 this.userInfoService.setLoginFlag(true);
    //                                 this.userInfoService.setToken(response.data.token);
    //                                 this.storageService.loginSubject.next(true);

    //                                 if (returnUrl) {
    //                                     this.router.navigateByUrl(decodeURIComponent(returnUrl)); // Redirect to the returnUrl
    //                                 } else {
    //                                     this.router.navigate(['my-dashboard']);
    //                                 }
    //                             }
    //                             else {
    //                                 this.storageService.removeValue(StorageKey.authToken);
    //                                 this.storageService.removeValue(StorageKey.currentUser);
    //                                 this.storageService.removeValue(StorageKey.rememberMe);
    //                                 this.alertService.showError(response.message);
    //                             }
    //                         },
    //                         error: (error) => {
    //                             this.storageService.removeValue(StorageKey.authToken);
    //                             this.storageService.removeValue(StorageKey.currentUser);
    //                             this.storageService.removeValue(StorageKey.rememberMe);
    //                             this.alertService.showError('Google Login failed');
    //                         },
    //                     });

    //                 }).catch((error) => {
    //                     this.storageService.removeValue(StorageKey.authToken);
    //                     this.storageService.removeValue(StorageKey.currentUser);
    //                     this.storageService.removeValue(StorageKey.rememberMe);
    //                     this.alertService.showError('Google Login failed');
    //                     console.error("Error fetching ID token:", error);
    //                 });
    //             })
    //         }
    //     }).catch((error) => {
    //         this.storageService.removeValue(StorageKey.authToken);
    //         this.storageService.removeValue(StorageKey.currentUser);
    //         this.storageService.removeValue(StorageKey.rememberMe);
    //         this.alertService.showError('Google Login failed');
    //         console.error('Google Login failed:', error);
    //     });
    // }

    checkEmailOrPhone() {
        this.showSubmitButton = false;
        if (this.loginForm.controls.email_phone.status == "INVALID") {
            return;
        }

        var logininfo: any = {
            "email": this.f.email_phone.value.trim()
        }

        this.loginService.check_auth_method(logininfo).subscribe((response: any) => {
            const passwordControl = this.loginForm.get('password');
            if (response.success) {
                if (response.data.exists) {
                    if (response.data?.authType === 'password') {
                        passwordControl?.setValidators([
                            Validators.required,
                            Validators.pattern('^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{6,20}$')
                        ]);
                        this.isShowPassword = true;
                        this.alertService.showSuccess(response.message);

                        this.showSubmitButton = true;
                    }
                    else if (response.data?.authType === 'google') {
                        //this.loginWithGoogle();
                        this.isShowPassword = false;
                        this.alertService.showError(response.message);
                    }
                    else {
                        passwordControl?.clearValidators();
                        this.isShowPassword = false;
                    }
                }
                else {
                    passwordControl?.clearValidators();
                    this.isShowPassword = false;

                    if (response.data?.validate == "email") {
                        this.activatedRoute.queryParams.subscribe(params => {
                            let returnUrl = params['returnUrl'];
                            if (returnUrl) {
                                this.router.navigate(['/register'], { queryParams: { returnUrl: returnUrl, email: this.f.email_phone.value.trim() } });
                            }
                            else
                                this.router.navigate(['/register'], { queryParams: { email: this.f.email_phone.value.trim() } });
                        })
                    }
                    this.alertService.showError("It looks like you haven’t registered yet. You can create an account or choose to sign in with Google");
                }
            }
            else {
                passwordControl?.clearValidators();
                this.isShowPassword = false;

                if (response.data?.validate == "email") {
                    this.activatedRoute.queryParams.subscribe(params => {
                        let returnUrl = params['returnUrl'];
                        if (returnUrl) {
                            this.router.navigate(['/register'], { queryParams: { returnUrl: returnUrl, email: this.f.email_phone.value.trim() } });
                        }
                        else
                            this.router.navigate(['/register'], { queryParams: { email: this.f.email_phone.value.trim() } });
                    })
                }
                this.alertService.showError(response.message);
            }
            passwordControl?.updateValueAndValidity();
        });
    }
}